export const environment = {
  production: false,
  isCert: true,
  channel: 'KIOSK',
  appName: 'KIOSK_AM_CERT',
  // #region CHECKIN
  /** Version de los endpoints cifrados de Check-in: {urlApiCheckinBFF}{versionCheckin}/kiosk/checkin/... */
  versionCheckin: '/v1',
  /** Version interna de passengerlist/standby y passengerListUpgrade: .../kiosk/checkin/passengerlist{versionPassengerList}/standby */
  versionPassengerList: '/v2',
  /** Version interna de eligibility: .../kiosk/checkin{versionEligibility}/eligibility */
  versionEligibility: '/v2',
  /** Version interna de updateDocuments: .../kiosk/checkin{versionUpdateDocuments}/updateDocuments */
  versionUpdateDocuments: '/v3',
  // #endregion
  // #region MYTRIPS
  /** Version de la ruta de MyTrips: {urlApiMyTrips}{versionMyTrips}/kiosk/mytrips/reservation. */
  versionMyTrips: '/v1',
  /** Version del BFF de MyTrips; viaja en el header versionBFF (formato 'v1') */
  versionSeamless: '',
  // #endregion
  // #region PAYMENTS
  versionPayments: '',
  // #endregion
  // #region LOYALTY
  versionBenefitsCore: '',
  versionBenefitsCoreCorporate: '',
  // #endregion
  /* KIOSK */
  cmsUrl: 'https://dev.amlab7.com/cms', // Error 403 CMS
  urlApi: '/checkIn',
  urlApiMicro: 'https://amx-c-chkibk-de.amlab7.com',
  /** Base de Check-in cifrado (incluye la ruta /host/api): {urlApiCheckinBFF}{versionCheckin}/kiosk/checkin/... */
  urlApiCheckinBFF: 'https://amx-c-kskam-de.amlab7.com/host/api',
  urlApiCheckin: 'https://amx-c-mtpsbk-de.amlab7.com',
  /** Base de MyTrips (incluye la ruta /host/api): {urlApiMyTrips}{versionMyTrips}/kiosk/mytrips/reservation. */
  urlApiMyTrips: 'https://amx-c-kskam-de.amlab7.com/host/api',
  urlApiMicroEligibility: 'https://amx-c-chkibk-de.amlab7.com',
  urlApiContactabilityAuth: 'https://gad94b3vra.execute-api.us-east-1.amazonaws.com/dev',
  urlApiContactability: 'https://y9rjsvk4lj.execute-api.us-east-1.amazonaws.com/dev',
  urlApiSelfReaccom: 'https://amx-c-slfcmbk-de.amlab7.com',
  urlApiAncillary: 'https://amx-c-alrsbk-de.amlab7.com',
  urlApiPayment: 'https://amx-c-pytsbk-de.amlab7.com',
  urlAncillaries: 'https://amx-c-alrsbk-de.amlab7.com',
  urlApiLoyal: 'https://amx-c-poflbk-de.amlab7.com',
  /* WEB */
  urlWeb: 'https://dev.amlab7.com/',
  /* API WEB */
  urlApiWeb: 'https://dev.amlab7.com/api',
  apiAWS: 'https://amx-c-chkibk-de.amlab7.com/',
  cmsVPro: 'https://www.aeromexico.com/cms/api/v1',
  cmsV2: 'https://dev.amlab7.com/',
  languages: {
    'es-MX': 'Español',
    'en-US': 'English',
    'fr-FR': 'Français',
    'du-NL': 'Nederlands',
    'pt-PT': 'Português',
    'ja-JP': '日本語',
    'zh-CN': '中文',
    'kr-KR': '한국어',
  },
  show24Format: true,
  isAM: true,
  apiNameContactability: 'eks-api-contactability',
  // Resolucion de vulnerabilidades Bolivia - junio 2026: CWE-798/CWE-259 - Credenciales inyectadas por CI/CD
  contactabilityAuth: '#{CONTACTABILITY}#',
  apiKeyGoogleMaps: '#{API_KEY_GOOGLE_MAPS}#',

  /* CIFRADO DE MICROSERVICIOS (RSA híbrido, igual que CUSS): el par RSA del kiosko se genera por sesión.
     checkinBffP: pública RSA del BFF de Check-in (PEM en Base64 de una línea); no es secreta.
     bypass solo puede ser true en environment.mock.ts. */
  publics: {
    bypass: false,
    checkinBffP:
      'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF3ekk5Zk1LTWFiUS9wMW4vM3o1Zgp6dDFrYnd6dGgwTDlacUVYdTk1NGdZRm82Vlh2azBuQ1BuTk1YVEZxc1oyb0FCZGpyaFdaQmxHVjA1RGgyWjFGCjNZSlZuYjY1dWtkQmsrb2hJclhSVWtZT0hLZktLckRIMEQ2YS82cmpEbXIvMWhkTWk5aTNoK0pHK1RZeHZ2azkKMjMycnZ0UFFUME0wUWRkbWs2ckEwcUpuZFEycU5lTHVpSHhMYzBQL2hvd3AvVXFEVktEM3I0cTREZUd2WlA0eApHajU2cVZyc2R5ajR0TVkzTVVEVzVxcHVhdHVCWmFxV25Sa2tBWUt4dGRYY3J1djNIdWovdVpWendhTEhLcTJ2CnZLeXBkc2tNV2sxQkE3WENLaTZnK2o5bmJOWUdyVDlOajAybDNCcDA1dVlpY2NKTGxkZU0raUVIcDFzUjJ2a2kKR3dJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==',
  },
};
